import { defineStore } from "pinia";
import RepositoryFactory from "@/repositories/apiGateWay/repositoryFactory";
const apiGatewayRepository = RepositoryFactory.get('apiGateway');
import ApplicationError from "@/helpers/applicationError";
import { API_RESPONSE_SUCCESS, HTTP_CODE_SUCCESS } from "@/data/constants";
import { dedupeIntegration } from "@sentry/vue";

export const useTopPageStore = defineStore('topPage', {
    state: () => ({
        isLoading: false,
        transactions: [],
        newsList: [],
        registeredApps: []
    }),
    persist: {
        //Do not persist sensitive data (ex: Name, email, password, address, etc)
        paths: ["registeredApps"],
    },
    getters: {

    },
    actions: {
        async getTopPageData() {
            this.isLoading = true;
            try {
                let sessionData = this.getSessionIdAndAuthId();
                apiGatewayRepository.ssid = sessionData.HVCHUBSYNCHSSID;
                apiGatewayRepository.auth_id = sessionData.auth_id;

                const toppageData = await apiGatewayRepository.getTopPageData({
                    limit: parseInt(process.env.VUE_APP_PAGINATION_LIMIT),
                    offset: 0
                });
                
                if (toppageData.data != null && toppageData.success == API_RESPONSE_SUCCESS) {
                    this.registeredApps = toppageData.data;
                }

                const paymentHistory = await apiGatewayRepository.getPaymentHistory({
                    "user_id": sessionData.hubsynch_id,
                    "limit": process.env.VUE_APP_PAGINATION_LIMIT,
                    "offset": 0
                });
                
                if (paymentHistory.success == API_RESPONSE_SUCCESS && paymentHistory.code == HTTP_CODE_SUCCESS) {
                    this.transactions = paymentHistory.data;
                }

                const newsList = await apiGatewayRepository.getNews({
                    "limit": process.env.VUE_APP_PAGINATION_LIMIT_SMALL,
                    "offset": 0
                });

                if (newsList.success == API_RESPONSE_SUCCESS && newsList.code == HTTP_CODE_SUCCESS) {
                    this.newsList = newsList.data;
                }
            } catch (e) {
                this.isLoading = false;
                throw new ApplicationError(e.message, {}, e)
            }
            this.isLoading = false;
        },
        getSessionIdAndAuthId() {
            return {
                'HVCHUBSYNCHSSID': localStorage.getItem('HVCHUBSYNCHSSID'),
                'auth_id': localStorage.getItem('auth_id'),
                'hubsynch_id': localStorage.getItem('hubsynch_id')
            }
        },
        getCurrentFormattedDate () {
            const now = new Date();
        
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0'); // Los meses van de 0 a 11
            const day = String(now.getDate()).padStart(2, '0');
        
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
        
            return `${year}-${month}-${day} ${hours}:${minutes}`;
        }
    }
});